/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_AvailableInputs */



/**
* | output |
* | --- |
* | "Update Available" |
*
* @param {Update_AvailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const update_available = /** @type {((inputs?: Update_AvailableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_AvailableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mise à jour disponible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Update verfügbar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiornamento disponibile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Доступно обновление")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualización disponible")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更新可用")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アップデートが利用可能です")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपलब्ध अद्यतन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualização disponível")
	return /** @type {LocalizedString} */ ("Update Available")
});